module.exports = __webpack_public_path__ + "static/media/iman-logistics.dc41cadb.png";